// frontend/src/services/bancoService.js

import api from './apiService';

/**
 * Busca a lista de todas as instituições financeiras (bancos).
 * @returns {Promise<Array>} Uma promessa que resolve para uma lista de bancos.
 */
export const getBancos = async () => {
    const response = await api.get('/financeiro/bancos/');
    return response.data;
};